var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarProduct({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5BFC\\u822A\\u56FE\\u6807",
    transform: "translate(-325.000000, -80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(325.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    fillOpacity: 0.01,
    fillRule: "nonzero",
    id: "\\u8DEF\\u5F84",
    points: "24 0 0 0 0 24 24 24"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "22 7 12 2 2 7 2 17 12 22 22 17",
    stroke: "#212121",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u8DEF\\u5F84",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    x1: 2,
    x2: 12,
    y1: 7,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u8DEF\\u5F84",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    x1: 12,
    x2: 12,
    y1: 22,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u8DEF\\u5F84",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    x1: 22,
    x2: 12,
    y1: 7,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u8DEF\\u5F84",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    x1: 17,
    x2: 7,
    y1: 4.5,
    y2: 9.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarProduct);
export default __webpack_public_path__ + "static/media/navbar_product.b65e41ab8b5334b5e2c600a6247c2642.svg";
export { ForwardRef as ReactComponent };